import type { AppConfigContextValue } from './types'

import { createContext } from 'react'

const defaultValue: AppConfigContextValue = {
  checkFeatureFlag: () => false,
  getRemoteConfig: () => ({}),
}

export const AppConfigContext =
  createContext<AppConfigContextValue>(defaultValue)
